import { getVariable } from '../utils';

const my = (window.my || {}) as MiniprogramApi;

my.getSiteInfo = ({ success }) => {
  if (!success) {
    return;
  }

  success({
    siteName: getVariable('siteName'),
  });
};

// @ts-ignore
my.openUrl = ({ url, target, success, fail }) => {
  if (!url) {
    if (fail) {
      fail();
    }
    return;
  }

  if (target === 'blank') {
    window.open(url);
  } else {
    window.location.href = url;
  }

  if (success) {
    success();
  }
};

window.my = my;
